import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import {
  Devices,
  FileReport,
  History,
  Home,
  LetterB,
  Link,
  ReceiptRefund,
  Users,
} from 'tabler-icons-react';
import { NavLinkType } from '../../type/navlink.types';
import AppHeader from './header/header.component';
import AppSidebar from './sidebar/sidebar.component';

const MerchantDashboardLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const navLinkProps: NavLinkType[] = [
    {
      order: 1,
      link: '/merchant/dashboard',
      label: 'Dashboard',
      icon: Home,
    },
    {
      order: 2,
      link: '/merchant/branches',
      label: 'Branches',
      icon: LetterB,
    },
    {
      order: 3,
      link: '/merchant/create-payment-links',
      label: 'Payment Links',
      icon: Link,
    },
    {
      order: 4,
      link: '/merchant/transactions',
      label: 'Transactions',
      icon: FileReport,
    },
    {
      order: 5,
      link: '/merchant/refund',
      label: 'Refund Approval',
      icon: ReceiptRefund,
    },
    {
      order: 6,
      link: '/merchant/logs',
      label: 'Logs',
      icon: History,
    },
    {
      order: 7,
      link: '/merchant/users',
      label: 'User Management',
      icon: Users,
    },
    {
      order: 8,
      sublinks: [
        { link: 'merchant/pos', label: 'View All POSs' },
        {
          link: '/merchant/pos/create',
          label: 'Create POS',
        },
      ],
      link: '',
      label: 'POS',
      icon: Devices,
    },
   
  ];

  return (
    <>
      <Helmet>
        <title>XPAY.World - Merchant Dashboard</title>
      </Helmet>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <AppShell
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
              '@media (max-width: 992px)': {
                paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
              },
            },
          }}
          navbarOffsetBreakpoint='md'
          asideOffsetBreakpoint='md'
          fixed
          navbar={<AppSidebar navLinkProps={navLinkProps} opened={opened} />}
          header={<AppHeader opened={opened} setOpened={setOpened} />}
        >
          <Outlet />
        </AppShell>
      </MantineProvider>
    </>
  );
};

export default MerchantDashboardLayout;
